import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=eb2b61a4"
import script from "./ProductGallery.vue?vue&type=script&lang=js"
export * from "./ProductGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb2b61a4')) {
      api.createRecord('eb2b61a4', component.options)
    } else {
      api.reload('eb2b61a4', component.options)
    }
    module.hot.accept("./ProductGallery.vue?vue&type=template&id=eb2b61a4", function () {
      api.rerender('eb2b61a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/ProductGallery.vue"
export default component.exports